/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSurveyShape } from './DataSurveyShape';
import {
    DataSurveyShapeFromJSON,
    DataSurveyShapeFromJSONTyped,
    DataSurveyShapeToJSON,
    DataSurveyShapeToJSONTyped,
} from './DataSurveyShape';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Serializer used by map that returns the least amount of
 * information necessary to render the map.
 * @export
 * @interface SiteMapList
 */
export interface SiteMapList {
    /**
     * 
     * @type {string}
     * @memberof SiteMapList
     */
    readonly id: string;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof SiteMapList
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {DataSurveyShape}
     * @memberof SiteMapList
     */
    shape?: DataSurveyShape | null;
}

/**
 * Check if a given object implements the SiteMapList interface.
 */
export function instanceOfSiteMapList(value: object): value is SiteMapList {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    return true;
}

export function SiteMapListFromJSON(json: any): SiteMapList {
    return SiteMapListFromJSONTyped(json, false);
}

export function SiteMapListFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteMapList {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'shape': json['shape'] === undefined ? undefined : json['shape'] === null ? null : DataSurveyShapeFromJSON(json['shape']),
    };
}

export function SiteMapListToJSON(json: any): SiteMapList {
    return SiteMapListToJSONTyped(json, false);
}

export function SiteMapListToJSONTyped(value?: Omit<SiteMapList, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'location': DataPointHistoryLocationToJSON(value['location']),
        'shape': DataSurveyShapeToJSON(value['shape']),
    };
}

